// extracted by mini-css-extract-plugin
module.exports = {"error":"accessrestricted_error__1szuL","top":"accessrestricted_top__xrsom","bottom":"accessrestricted_bottom__y1nhI","returnToSignIn":"accessrestricted_returnToSignIn__3VxnX"};